<t4-header icon="glyphicon-stats"></t4-header>
<t4-container>
    <t4-data-table #tbl apiMethod="RentalObject/GetObjectsReport" headline="" matSort></t4-data-table>
</t4-container>